import { formatScore } from '@repo/common/utils/dataQuality';

export function renderScore(
	scoreType: 'points' | 'percentage',
	score: number,
	max: number
) {
	if (score === -1) {
		return '-';
	}

	if (scoreType === 'points') {
		return `${formatScore(score)}/${max}`;
	}

	return `${formatScore((score / max) * 100)}%`;
}
